
import { defineComponent, PropType } from 'vue';
import { ConcordanceVerse } from '@/interfaces/ConcordanceVerse';

export default defineComponent({ props: { verses: Array as PropType<Array<ConcordanceVerse>> } });
